import React from 'react'
import { SiLinux, SiPostman, SiRabbitmq, SiDocker, SiGithub } from 'react-icons/si'

const tools = [
  { icon: <SiLinux />, label: 'Linux' },
  { icon: <SiGithub />, label: 'GitHub' },
  { icon: <SiDocker />, label: 'Docker' },
  { icon: <SiRabbitmq />, label: 'RabbitMQ' },
  { icon: <SiPostman />, label: 'Postman' },
]

function Toolstack() {
  return (
    <div className="skills-grid">
      {tools.map(t => (
        <div key={t.label} className="skill-chip">
          {t.icon}
          <span>{t.label}</span>
        </div>
      ))}
    </div>
  )
}

export default Toolstack
